import React from "react";
import {
  IconBrandWhatsapp,
  IconBrandInstagram,
  IconBrandMessenger,
} from "@tabler/icons-react";
import "./ChannelBadge.css";

const CHANNEL_META = {
  whatsapp: {
    Icon: IconBrandWhatsapp,
    color: "#25D366",
    label: "WhatsApp",
  },
  instagram: {
    Icon: IconBrandInstagram,
    color: "#E4405F",
    label: "Instagram",
  },
  messenger: {
    Icon: IconBrandMessenger,
    color: "#0084FF",
    label: "Messenger",
  },
};

/**
 * Badge de canal — variantes:
 *   - variant="avatar"  (default): círculo branco com ícone, posição absolute
 *     pra sobrepor avatar. Tamanho 16px, ícone 12px.
 *   - variant="inline":            chip com ícone + label, pra usar em header
 *     da conversa ("via WhatsApp").
 *   - variant="dot":               círculo colorido sólido pequeno (8px).
 */
const ChannelBadge = ({
  channel,
  variant = "avatar",
  identity = null,
  size = null,
}) => {
  const meta = CHANNEL_META[channel] || CHANNEL_META.whatsapp;
  const { Icon, color, label } = meta;

  if (variant === "inline") {
    return (
      <span
        className={`sc-channel-badge sc-channel-badge--inline sc-channel-badge--${channel}`}
        style={{ color, background: `${color}15` }}
        title={identity ? `via ${label} · ${identity}` : `via ${label}`}
      >
        <Icon size={15} className="sc-channel-badge__icon" />
        <span className="sc-channel-badge__prefix">via {label}</span>
        {identity && (
          <>
            <span className="sc-channel-badge__sep" aria-hidden="true">·</span>
            <span className="sc-channel-badge__identity">{identity}</span>
          </>
        )}
      </span>
    );
  }

  if (variant === "dot") {
    const s = size || 8;
    return (
      <span
        className="sc-channel-badge sc-channel-badge--dot"
        title={label}
        style={{
          display: "inline-block",
          width: s,
          height: s,
          background: color,
          borderRadius: "50%",
        }}
      />
    );
  }

  // variant="avatar" (default)
  // Design "soft tint": fundo branco com camada translúcida da cor do canal +
  // ring fino colorido + ring branco externo (separação do avatar abaixo) +
  // sombra de elevação. Ícone vibrante na cor sólida do canal.
  const s = size || 20;
  return (
    <span
      className={`sc-channel-badge sc-channel-badge--avatar sc-channel-badge--${channel}`}
      title={label}
      style={{
        position: "absolute",
        bottom: -2,
        right: -2,
        backgroundColor: "#fff",
        backgroundImage: `linear-gradient(135deg, ${color}33, ${color}1a)`,
        borderRadius: "50%",
        display: "inline-flex",
        boxShadow: `0 0 0 1.5px #fff, inset 0 0 0 1px ${color}40, 0 1px 3px rgba(15,23,42,0.12)`,
        color: color,
        width: s,
        height: s,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon size={s - 5} stroke={2.4} />
    </span>
  );
};

export default ChannelBadge;
